module.exports = __webpack_public_path__ + "e72d4ea73a7fd70105e9dba7633e2121.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/ppu.jpg
 ** module id = 445
 ** module chunks = 0
 **/